import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from './ui/dropdown-menu';

const LANGS = [
  { code: 'ms', label: 'Bahasa Melayu', short: 'BM' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'id', label: 'Bahasa Indonesia', short: 'ID' },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  const change = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('mtsr_lang', code);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className="inline-flex items-center gap-1.5 h-11 px-3 rounded-lg border border-border bg-card text-foreground hover:bg-muted transition-colors text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
        >
          <Globe className="h-4 w-4 text-brand" />
          <span>{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-${l.code}`}
            onClick={() => change(l.code)}
            className={l.code === current.code ? 'font-semibold text-brand' : ''}
          >
            <span className="w-7 text-xs font-bold text-muted-foreground">{l.short}</span>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
